const tr = {
    en: {
        failTitle: "Oops!",
        failmsg1: "Something went wrong and we weren''t able to set up your account for payment.",
        failmsg2: "Please try again later or contact 1O1O (2888 1010) or csl (2512 3123) or Club Sim (183 3123) for help. Thank you.",

        continueBtnTxt: "OK",
    },
    zh: {
        failTitle: "抱歉!",
        failmsg1: "我們未能設定您的賬單付款。",
        failmsg2: "請稍後再試，或聯絡1O1O (2888 1010) 或 csl (2512 3123) 或 Club Sim (183 3123)查詢詳情，謝謝。",

        continueBtnTxt: "確定",
    }
}

export default tr;
